<div class="auth-background">
  <app-topbar></app-topbar>
  <router-outlet></router-outlet>
</div> 